var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsMain',[_c('WsCRUD',{attrs:{"orderWay":"asc","orderBy":"sequence","label":_vm.label,"fields":_vm.fields,"modelName":_vm.modelName,"showFields":_vm.showFields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }